import React from 'react';

const STATUS_LABEL = {
  issued: 'صادرة',
  paid: 'مدفوعة',
  cancelled: 'ملغاة'
};

const STATUS_CLASS = {
  issued: 'inv-badge--issued',
  paid: 'inv-badge--paid',
  cancelled: 'inv-badge--cancelled'
};

const InvoiceStatusBadge = ({ status, refundsCount = 0 }) => {
  const label = STATUS_LABEL[status] || status;
  const cls = STATUS_CLASS[status] || '';
  const showRefundFlag = status === 'paid' && refundsCount > 0;

  return (
    <span className={`inv-badge ${cls}${showRefundFlag ? ' inv-badge--refunded' : ''}`}>
      {label}
      {showRefundFlag && <span className="inv-badge__refund-flag"> (استرداد)</span>}
    </span>
  );
};

export default InvoiceStatusBadge;
